<div class="app-container">
  <page-header [icon]="'far-list-alt'" [title]="'productMoves.transfer.list'" [isStockOperation]="true">
    <ng-container class="header-btn">
      <div class="flex-gap-5 align-items-center">
        <modal-stock-operation-card
          #modalStockOperation
          [hideButton]="true"
          [alwaysLoadSelectData]="true"
          [isCreatingProduct]="false"
          [producers]="producers"
          [vats]="vats"
          [depotFrom]="selectedDepotFrom"
          [depotTo]="selectedDepotTo"
          [type]="'transfer'"
          [depots]="depots"
          [suppliers]="suppliers"
          (result)="addOperationToList($event)"
        >
        </modal-stock-operation-card>
        <btn
          [label]="'product.transfer'"
          [title]="'product.transfer' | translate"
          [icon]="'far-layer-minus'"
          [classes]="['btn-first-orange', 'btn-sm']"
          (onEvent)="createStockLoad()"
          *ngIf="!loading && operations.length > 0"
          data-cy="submit-stock-form"
        >
        </btn>
      </div>
      <div class="row d-flex flex-gap-10 ml-0">
        <div class="form-group mb-0 flex-gap-5 align-items-center">
          <label class="mb-0 text-nowrap">{{ 'depot.from' | translate }}:</label>
          <select
            name="depot"
            class="form-control custom"
            [ngModel]="selectedDepotFrom"
            (ngModelChange)="depotFromSelected($event)"
            [disabled]="operations?.length > 0 && !isClonedPmp"
            data-cy="select-depot-from"
          >
            <ng-template ngFor let-depot [ngForOf]="depots">
              <option value="{{ depot.id }}">{{ depot.name }}</option>
            </ng-template>
          </select>
        </div>

        <div *ngIf="selectedDepotFrom">
          <div class="form-group mb-0 flex-gap-5 align-items-center">
            <label class="mb-0 text-nowrap">{{ 'depot.to' | translate }}:</label>
            <select
              name="depotSelectTo"
              id="depotSelectTo"
              class="form-control custom"
              [(ngModel)]="selectedDepotTo"
              [disabled]="operations?.length > 0 && !isClonedPmp"
              data-cy="select-depot-to"
            >
              <ng-template ngFor let-depot [ngForOf]="depots">
                <option value="{{ depot.id }}">{{ depot.name }}</option>
              </ng-template>
            </select>
          </div>
        </div>
      </div>
    </ng-container>
  </page-header>
  <div class="container-fluid">
    <div class="row cards-responsive">
      <div class="col-12 col-sm-12 col-1100 col-lg-6 col-xl-6 pl-0">
        <div class="card mb-0" *ngIf="!isPrintingEANs">
          <div class="row" *ngIf="selectedDepotFrom">
            <div class="col-12 col-sm-12">
              <div class="form-group pl-0 pr-0 ml-0 mr-0 pt-2">
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    [(ngModel)]="searchFulltext"
                    (keydown)="filterKeyDown($event)"
                  />
                  <div class="input-group-btn">
                    <button type="button" class="btn-search" (click)="search()" [title]="'filter' | translate">
                      <i class="far fa-search"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row" *ngIf="loading" [ngClass]="{ h150: !products.length && loading }"></div>

          <div
            *ngIf="!products || (products && products.length === 0 && !loading && selectedDepotFrom)"
            class="margin text-center"
            style="padding: 1.625rem"
          >
            {{ 'no.items' | translate }}
          </div>

          <div class="row prod-list-scrolling">
            <div class="col">
              <div class="tableWrapper">
                <table class="table table-responsive" [ngClass]="{ h150: !products.length && loading }">
                  <loading-spinner
                    [isLoading]="loading && ((searchFulltext && searchFulltext.length > 0) || currentPage === 1)"
                    [classesString]="'pt-6'"
                  ></loading-spinner>
                  <div *ngIf="products.length > 0">
                    <thead>
                      <tr>
                        <th class="pl-0">{{ 'product.name' | translate }}</th>
                        <th class="text-center fixed-column-width">
                          {{ ('product.expirationDate' | translate) + ', ' + ('product.batch' | translate) }}
                        </th>
                        <th class="text-center fixed-column-width">{{ 'products.availability' | translate }}</th>
                        <th class="fixed-column-width"></th>
                      </tr>
                    </thead>
                    <div *ngIf="!loading && !selectedDepotFrom" class="margin text-center" style="padding: 1.625rem">
                      {{ 'depot.select' | translate }}
                    </div>
                    <tbody *ngIf="products && products.length > 0" class="images" [photoGalleryGroup]="{ index: 1 }">
                      <ng-container *ngFor="let prod of products">
                        <tr *ngFor="let pDepot of getProductDepotsWithQuantity(prod)">
                          <td class="pl-1 custom-product-td" [ngClass]="{ 'disabled-product': !prod.enabled }">
                            <div class="flex-gap-10 align-items-center">
                              <div
                                [photoGallery]="getThumbUrl(prod.mainImage, 'w2048wp')"
                                [photoGalleryCaption]="
                                  prod
                                    ? prod.fullName +
                                      '<br>' +
                                      (prod.code ? ('stock-transfer-page.code' | translate) + prod.code : '') +
                                      '<br>' +
                                      (prod.ean ? ('stock-transfer-page.ean' | translate) + prod.ean : '')
                                    : ''
                                "
                              >
                                <div class="images-item">
                                  <img
                                    class="images-item-image"
                                    [src]="getThumbUrl(prod.mainImage)"
                                    [alt]="prod.fullName"
                                  />
                                </div>
                              </div>
                              <div>
                                <div>
                                  <a class="link-bold product-name-nowrap-wrapper" [routerLink]="['/product', prod.id]">
                                    {{ prod ? prod.fullName : '' }}
                                  </a>
                                </div>
                                <div class="input-group-append flex-wrap product-center">
                                  <div class="product-details" *ngIf="prod.code">
                                    {{ 'product.code' | translate }}:<span
                                      [ngClass]="{ 'disabled-product': !prod.enabled }"
                                    >
                                      {{ prod.code }}</span
                                    >
                                  </div>
                                  <div class="product-details" *ngIf="prod.ean">
                                    {{ 'product.ean' | translate }}:<span
                                      [ngClass]="{ 'disabled-product': !prod.enabled }"
                                    >
                                      {{ prod.ean }}</span
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                          </td>
                          <td class="text-center">
                            <div>
                              {{ pDepot.expirationDate | fmtDate: 'dd.MM.yyyy' }}
                            </div>
                            <div>
                              {{ pDepot.batch }}
                            </div>
                          </td>
                          <td class="text-center">
                            {{ getDepotQuantity(pDepot) }}
                          </td>
                          <td class="pr-1">
                            <div class="flex-gap-10 align-items-center">
                              <div>
                                <modal-stock-operation-card
                                  [product]="prod"
                                  [moves]="operations"
                                  [productDepot]="pDepot"
                                  [depotFrom]="selectedDepotFrom"
                                  [depotTo]="selectedDepotTo"
                                  [type]="'transfer'"
                                  [producers]="producers"
                                  [vats]="vats"
                                  [suppliers]="suppliers"
                                  [depots]="depots"
                                  [initDateDUZP]="initDateDUZP"
                                  [depotQuantity]="pDepot.quantityStock"
                                  (result)="operationListChange($event)"
                                  data-cy="operation-card"
                                >
                                </modal-stock-operation-card>
                              </div>
                            </div>
                          </td>
                        </tr>
                      </ng-container>
                    </tbody>
                  </div>
                </table>
              </div>
            </div>
          </div>
          <app-pagination-btn
            *ngIf="(!this.currentPage || this.currentPage <= this.endPage) && this.totalItems > this.products.length"
            (switchPage)="search(currentPage, true)"
            [minViewportWidth]="1100"
            [endPage]="endPage"
            [loadingPage]="loading"
            [currentPage]="currentPage"
          >
          </app-pagination-btn>
        </div>
        <div class="row" *ngIf="isPrintingEANs">
          <div class="col-12">
            <barcode-list-print-array [operations]="operations"></barcode-list-print-array>
          </div>
        </div>
      </div>

      <div class="col-12 col-sm-12 col-1100 col-lg-6 col-xl-6 pr-0">
        <div class="card mb-0">
          <div class="flex-row">
            <btn
              *ngIf="isPrintingEANs"
              [label]="'select.invert'"
              [title]="'select.invert' | translate"
              [icon]="'far-exchange'"
              [classes]="['btn-third', 'float-right', 'mr-2']"
              (onEvent)="printingSelect('invert')"
            ></btn>
            <btn
              *ngIf="isPrintingEANs"
              [label]="'select.none'"
              [title]="'select.none' | translate"
              [icon]="'far-square'"
              [classes]="['btn-third', 'float-right', 'mr-2']"
              (onEvent)="printingSelect('none')"
            ></btn>
            <btn
              *ngIf="isPrintingEANs"
              [label]="'select.all'"
              [title]="'select.all' | translate"
              [icon]="'far-check-square'"
              [classes]="['btn-third', 'float-right', 'mr-2']"
              (onEvent)="printingSelect('all')"
            ></btn>
          </div>
          <div class="row" *ngIf="!isPrintingEANs">
            <div class="col d-flex align-self-center">
              <div class="card-title" data-cy="batch-title">
                {{ 'stock.transfer.list' | translate }}
              </div>
            </div>
            <div class="col mt-md-1 d-flex justify-content-end">
              <btn
                [label]="'clear.options'"
                [title]="'clear.options' | translate"
                [icon]="'far-trash-alt'"
                [classes]="['btn-first-red', 'btn-sm', 'mr-2']"
                (onEvent)="clearList()"
                *ngIf="!isPrintingEANs && operations && operations.length > 0"
                data-cy="cancel-stock"
              ></btn>
              <btn
                *ngIf="operations && operations.length > 0"
                [label]="'print'"
                [title]="'print' | translate"
                [icon]="'far-print'"
                [classes]="['btn-third', 'btn-sm', 'mr-2']"
                (onEvent)="printList()"
                data-cy="print-products"
              ></btn>
            </div>
          </div>
          <div
            *ngIf="!operations || (operations && operations.length === 0)"
            style="text-align: center; padding: 1.625rem"
          >
            <div class="empty-list">
              <i class="far fa-sad-tear"></i>
              <div>
                {{ 'empty.list' | translate }}
              </div>
            </div>
          </div>
          <div
            class="table-responsive no-print"
            *ngIf="operations?.length > 0"
            [ngClass]="{ 'scrollable-list-short': isPrintingEANs }"
          >
            <table class="width-fill-available m-0">
              <thead>
                <tr>
                  <th *ngIf="isPrintingEANs" class="text-align-center padding-right-05">
                    {{ 'product.printEAN' | translate }}
                  </th>
                  <th>{{ 'product.name' | translate }}</th>
                  <th class="padding-right-05 text-align-center">{{ 'quantity' | translate }}</th>
                  <th *ngIf="!isPrintingEANs">&nbsp;</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let operation of operations">
                  <td *ngIf="isPrintingEANs" class="text-align-center">
                    <input type="checkbox" [(ngModel)]="operation.isEANPrintable" (change)="refreshOperationsHack()" />
                  </td>
                  <td class="flex-gap-10 align-items-center" *ngIf="operation.product">
                    <product-image [product]="operation.product"></product-image>
                    <div>
                      <a class="link-bold align-self-center" [routerLink]="['/product', operation.product.id]">
                        {{ operation.product ? operation.product.fullName : '' }}
                      </a>
                      <div class="flex-column-gap-10 flex-wrap flex-direction-row">
                        <div class="flex-gap-5 flex-wrap product-details" *ngIf="operation.product.code">
                          {{ ('product.code' | translate) + ': ' + operation.product.code }}
                        </div>
                        <div class="flex-gap-5 flex-wrap product-details" *ngIf="operation.product.ean">
                          {{ ('product.ean' | translate) + ': ' + operation.product.ean }}
                        </div>
                        <div class="flex-gap-5 flex-wrap product-details" *ngIf="operation.batch">
                          {{ !!operation.batch ? ('product.batch' | translate) + ': ' + operation.batch : '' }}
                        </div>
                        <div *ngIf="!!operation.expirationDate" class="flex-gap-5 flex-wrap product-details">
                          {{
                            !!operation.expirationDate
                              ? ('product.expirationDate' | translate) +
                                ': ' +
                                (operation.expirationDate | fmtDate: 'dd.MM.yyyy')
                              : ''
                          }}
                        </div>
                        <div
                          class="flex-gap-5 flex-wrap product-details"
                          *ngIf="
                            companyUtil.arePositionsEnabled &&
                            (!!operation.position1 || !!operation.position2 || !!operation.position3)
                          "
                        >
                          {{
                            !!operation.position1 || !!operation.position2 || !!operation.position3
                              ? ('position' | translate) +
                                ': ' +
                                operation.position1 +
                                '-' +
                                operation.position2 +
                                '-' +
                                operation.position3
                              : ''
                          }}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td class="width-max-content text-nowrap text-center">
                    {{ operation.amount || 0 }}
                  </td>
                  <td *ngIf="!isPrintingEANs" class="pr-1 width-max-content">
                    <div class="flex-gap-5 align-self-center float-right">
                      <btn
                        [title]="'delete' | translate"
                        [icon]="'far-trash-alt'"
                        (onEvent)="removeOperation(operation)"
                        [classes]="['btn-sm', 'btn-trash']"
                      >
                      </btn>
                    </div>
                  </td>
                </tr>
                <tr *ngIf="operations?.length && !isPrintingEANs">
                  <td class="no-hover">
                    <strong>{{ 'sum' | translate }}</strong>
                  </td>
                  <td class="text-right text-nowrap no-hover">
                    <div class="flex-gap-10 justify-content-end">
                      <strong>{{ 'bill.quantity' | translate }}: {{ operations | listLength }}</strong>
                      <strong>/</strong>
                      <strong
                        >{{ 'bill.amount' | translate }}: {{ operations | operationsPriceSum: ['quantity'] }}</strong
                      >
                    </div>
                  </td>
                  <td class="no-hover">&nbsp;</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="mt-2" *ngIf="!isPrintingEANs">
            <div class="col-12 pl-0 pr-0">
              <div class="operation-list mt-2 advanced">
                <div class="row">
                  <div class="col-12">
                    <div class="operation-card">
                      <form-row-textarea
                        [label]="'note'"
                        [icon]="null"
                        [model]="note"
                        (modelChange)="updateNote($event)"
                        data-cy="stock-note"
                      ></form-row-textarea>
                    </div>
                  </div>
                </div>
                <div class="operation-card mt-2">
                  <div class="row" *ngIf="uploadedFiles && uploadedFiles.length > 0">
                    <div class="col-12 pr-0">
                      <div class="table-responsive">
                        <table class="w-100">
                          <tbody>
                            <tr *ngFor="let f of uploadedFiles">
                              <td class="pl-1">
                                <div class="flex-gap-10">
                                  <i class="far fa-file-alt align-self-center"></i>
                                  <span class="file-name">{{ f['filename'] }}</span>
                                </div>
                              </td>
                              <td class="pr-1">
                                <btn
                                  [title]="'delete' | translate"
                                  [icon]="'far-trash-alt'"
                                  [classes]="['btn-trash', 'btn-sm', 'float-right']"
                                  (onEvent)="removeUploadedFile(f)"
                                ></btn>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <loading-spinner [isLoading]="areFilesUploading" [classesString]="'top-25'"></loading-spinner>
                      <form-row-input
                        [label]="'files'"
                        [icon]="'far-upload'"
                        [inputType]="'file'"
                        [inputMultiple]="true"
                        (valueChangeNative)="uploadFiles($event)"
                      ></form-row-input>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
